import { render, staticRenderFns } from "./daily-tab.vue?vue&type=template&id=27fccc6e"
import script from "./daily-tab.vue?vue&type=script&lang=js"
export * from "./daily-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports